import React, {useEffect} from 'react';
import styled from 'styled-components';
import AuthorProfile from "../../Profile/SubPage/AuthorProfile";
import {Contents} from "../../../components";
import CloseIcon from "../../../../assets/images/icon/CloseIcon";
import CloseCircle from "../../../../assets/images/icon/CloseCircle";

const InstructorPopup = (props) => {

    useEffect(() => {
        document.addEventListener("keydown",(e)=>{
            if(e.keyCode === 27){
                props.onClickPopup()
            }
        })
    }, []);
return(
  <Container>
      <Icon >
          <div className="close" onClick={() => {
              props.onClickPopup()
          }}>
              <CloseIcon/>
          </div>
      </Icon>
      <Inner>
          <Contents>
              <AuthorProfile id={props.id}/>
          </Contents>
      </Inner>
  </Container>
)
}
export default InstructorPopup;

const Container = styled.div`
    padding: 10px;
    border-radius: 10px;
    height: 700px;
    background: #fff;
    padding-bottom: 40px;
`;
const Inner = styled.div`
    height: 100%;
    overflow: auto;
    width: 1000px;
    border-radius: 10px;
    position: relative;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`
const Icon = styled.div`
    top: 10px;
    opacity: 0.6;
    display: flex;
    justify-content: flex-end;
    right: 10px;
    cursor: pointer;
    position: relative;
    svg{
        width: 30px;
        height: 30px;
        color: #fff;
        path{
            stroke-width: 1px;
            stroke: #fff;
            fill: #fff;
        }
    }
    .close{
        transform: translate(50%, -50%);
        left: 100%;
        bottom: 100%;
        z-index: 999999;
        position: absolute;
        display: flex;
        align-items: center;
    }
`
